/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_ProcessingInputs */

const vi_import_processing = /** @type {(inputs: Import_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang import khách hàng, vui lòng chờ...`)
};

/**

* @param {Import_ProcessingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_processing = /** @type {((inputs?: Import_ProcessingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_ProcessingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_processing(inputs)
});